import React from 'react';
import styled from 'styled-components';
import { useAppDispatch } from '@/reduxStore/rootReducer';
import { Modal } from '@monavate/ui-core';
import { closeCreateIbanClientModal, triggerIbansRefresh } from '@/reduxStore/slices/ibansSlice';
import { onboardingApi } from '@/services/rest/apiInstances';
import { addNotification } from '@/reduxStore/slices/systemNotificationSlice';
import { getErrorMessageFromResponse } from '@/utils/errorHandling';
import { useParams } from 'react-router-dom';

const ModalWrap = styled.div`
    padding: 0;
`;

interface ModalProps {
    isOpen: boolean;
}

const CreateIbanModal: React.FC<ModalProps> = ({ isOpen }) => {
    const params = useParams();
    const clientId = params.clientId!;
    const dispatch = useAppDispatch();

    const handleClose = () => {
        dispatch(closeCreateIbanClientModal());
    };

    const handleCreateIban = async () => {
        try {
            await onboardingApi.setupIbans({ clientId });
            dispatch(
                addNotification({
                    message: 'IBANs created successfully.',
                    status: 'success',
                }),
            );
            setTimeout(() => dispatch(triggerIbansRefresh()), 1000);
            dispatch(closeCreateIbanClientModal());
        } catch (error: any) {
            dispatch(
                addNotification({
                    message: getErrorMessageFromResponse(error, 'Something went wrong'),
                    status: 'error',
                }),
            );
        }
    };

    return (
        <Modal
            width={456}
            open={isOpen}
            title={'Create IBANs'}
            onClose={handleClose}
            contentGap={16}
            onSubmit={handleCreateIban}
            submitTitle="Confirm"
        >
            <ModalWrap>
                <p>
                    Pre-fund and settlement IBANs will be created for all configured currencies of
                    this client.
                </p>
                <p>
                    To change currencies, please update the client’s <b>configuration</b> before
                    proceeding.
                </p>
            </ModalWrap>
        </Modal>
    );
};

export default CreateIbanModal;
